import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'iview'
import locale from 'iview/dist/locale/ja-JP'
import './assets/less/iview/custom.less'
import './assets/scss/_var.scss'
import './assets/scss/_mixin.scss'
import './assets/scss/style.scss'
import VueLocalForage from 'vue-localforage'
import VueLodash from 'vue-lodash'
import VueAnalytics from 'vue-analytics'
import deviceLib from './plugins/device-lib'
import pdfApisLib from './plugins/pdf-apis-lib'
import Axios from './plugins/my-axios'
import eventHub from './plugins/event-hub'
import dateComponent from './components/parts/DateComponent'
import firebaseLib from './plugins/firebase-lib'
import planConfig from './plugins/plan-config-lib'

Vue.config.productionTip = false
Vue.use(iView, { locale })
Vue.use(VueLocalForage)
Vue.use(VueLodash)
Vue.use(VueAnalytics, {
  id: 'UA-127745915-1'
})
Vue.use(deviceLib)
Vue.use(pdfApisLib)
Vue.use(Axios)
Vue.use(eventHub)
Vue.use(firebaseLib)
Vue.use(planConfig)
Vue.component('my-date', dateComponent)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
